import React from 'react';
import { Typography, Space } from 'antd';
import { motion } from 'framer-motion';
import { standardVariants, containerVariants } from '../../utils/useAnimations';
import { AccessibleButton } from '../../components/AccessibleButton';
import { AccessibleImage } from '../../components/AccessibleImage';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

export const Hero: React.FC = () => {
  const navigate = useNavigate();
  return (
    <section 
      className="max-w-[1440px] mx-auto p-20 pt-40 flex gap-[32px] justify-center"
      role="main"
    >
      <div className="flex items-center justify-between gap-10">
        <motion.div 
          className="flex flex-col w-[50%] gap-4"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        > 
          <motion.div variants={standardVariants}>
            <Title level={1} className="!text-[40px] !font-bold !mb-4 !text-neutral-black"> 
              Andy K. à la découverte des handicaps dans le numérique.
            </Title>
          </motion.div>
          
          <motion.div variants={standardVariants}>
            <Paragraph className="!text-neutral-600 !text-lg !leading-relaxed !mb-6">
              Mettez-vous dans la peau de notre explorateur numérique et découvrez comment les personnes en situation de handicap perçoivent et interagissent avec le web.<br/>Un parcours pour mieux comprendre les barrières du numérique.
            </Paragraph>
          </motion.div>
          
          <motion.div variants={standardVariants}>
            <Space size="middle">
              <AccessibleButton 
                type="primary" 
                ariaLabelKey="buttons.startAdventure"
                onClick={() =>{ navigate(`/#parcours`)}}
              >
                Commencer l'aventure
              </AccessibleButton>
              <AccessibleButton 
                type="secondary"
                ariaLabelKey="buttons.moreInfoProject"
                onClick={() =>{ navigate(`/#projet`)}}
              >
                Plus d'infos le projet
              </AccessibleButton>
            </Space>
          </motion.div>
        </motion.div>
        
        <motion.div 
          className="w-[50%] h-75 flex items-center justify-center relative"
          variants={standardVariants}
          initial="hidden"
          animate="visible"
        >
          <AccessibleImage 
            src="/img/svg/imageHeroAndyK.svg" 
            altKey="images.heroCharacter"
            className="z-[2] relative max-w-[164px] self-justify-center" 
          />
          <AccessibleImage 
            src="/img/svg/imageHeroHandicaps.svg" 
            altKey="images.heroDisabilities"
            className="absolute blur-lg max-w-[615px] self-justify-start flex"
            isDecorative={true}
          />
        </motion.div>
      </div>
    </section>
  );
};